// extracted by mini-css-extract-plugin
module.exports = {"form-container":"PasswordSection_form-container__kuHAL"};